export default __webpack_public_path__ + "static/media/google_logo.7b63c4b3.jpg";